var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { decodeJwt } from "jose";
import { immer } from "zustand/middleware/immer";
import { merge } from "lodash";
import { z } from "zod";
import apiRoutes from '@/actions/api';
import moment from "moment";
export var useCreditStore = create()(persist(immer(function (set, get) { return ({
    credits: [],
    retrieveBalance: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var companyIdSchema, companyIdParsed, endpoint, response_1, _c, tokenData_1, decodingError, err_1, error;
        var companyId = _b.companyId;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    companyIdSchema = z.coerce.number().int().positive();
                    return [4 /*yield*/, companyIdSchema.spa(companyId)];
                case 1:
                    companyIdParsed = _d.sent();
                    if (!companyIdParsed.success) {
                        throw new Error("Invalid company ID.");
                    }
                    if (!window.navigator.onLine) {
                        console.error("[".concat(moment().format('HH:mm:ss'), "] Can't retrieve credit balance for company ").concat(companyId, " because the user is offline."));
                        return [2 /*return*/];
                    }
                    endpoint = apiRoutes.companies.credits.replace(':company', companyId);
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, window.axios.get(endpoint)];
                case 3:
                    response_1 = _d.sent();
                    _c = get().decodeBalanceToken({ token: response_1.data.balanceToken }), tokenData_1 = _c.data, decodingError = _c.error;
                    if (decodingError) {
                        throw decodingError;
                    }
                    console.log("[".concat(moment().format('HH:mm:ss'), "] Retrieved credit balance for company ").concat(tokenData_1.companyId, ": ").concat(tokenData_1.creditBalance));
                    set(function (state) {
                        var creditSet = state.credits.find(function (credit) { return credit.companyId === companyId.toString(); });
                        if (creditSet) {
                            creditSet.balanceToken = response_1.data.balanceToken;
                            creditSet.companyId = tokenData_1.companyId;
                            creditSet.lastSync = moment().unix().toString();
                        }
                        else {
                            state.credits.push({
                                companyId: tokenData_1.companyId,
                                balanceToken: response_1.data.balanceToken,
                                reservedCredits: 0,
                                lastSync: moment().unix().toString()
                            });
                        }
                    });
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _d.sent();
                    error = err_1;
                    console.error("[".concat(moment().format('HH:mm:ss'), "] Error while retrieving / decoding credit balance for company ").concat(companyId, ": ").concat(error.message));
                    throw error;
                case 5: return [2 /*return*/];
            }
        });
    }); },
    refreshBalances: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("[".concat(moment().format('HH:mm:ss'), "] Refreshing credit balances..."));
                    return [4 /*yield*/, Promise.all(get().credits.map(function (credit) { return get().retrieveBalance({ companyId: credit.companyId }); }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    decodeBalanceToken: function (_a) {
        var token = _a.token;
        var tokenSchema = z.object({
            companyId: z.coerce.number().int().min(0),
            creditBalance: z.number().int().min(0),
        });
        var decoded = decodeJwt(token);
        var parsed = tokenSchema.safeParse(decoded);
        if (!parsed.success) {
            return {
                data: null,
                error: new Error("Invalid values found while decoding credit balance token.")
            };
        }
        return {
            data: {
                companyId: parsed.data.companyId.toString(),
                creditBalance: parsed.data.creditBalance
            },
            error: null,
        };
    },
    refreshTimer: {
        timerInstance: null,
        start: function () {
            if (get().refreshTimer.timerInstance) {
                get().refreshTimer.stop();
            }
            var interval = moment.duration(30, 'seconds').asMilliseconds();
            var timer = setInterval(function () { return get().refreshBalances(); }, interval);
            console.log("[".concat(moment().format('HH:mm:ss'), "] Started credit balance refresh timer."));
            set(function (state) {
                state.refreshTimer.timerInstance = timer;
            });
        },
        stop: function () {
            var timer = get().refreshTimer.timerInstance;
            if (timer !== null) {
                console.log("[".concat(moment().format('HH:mm:ss'), "] Stopped credit balance refresh timer."));
                clearInterval(timer);
                set(function (state) {
                    state.refreshTimer.timerInstance = null;
                });
            }
        }
    },
    creditHandlers: {
        reserveCreditForScan: function (_a) {
            var _b;
            var companyId = _a.companyId;
            var CREDITS_NEEDED_FOR_SINGLE_SCAN = 1;
            var balanceToken = (_b = get().credits.find(function (credit) { return credit.companyId === companyId.toString(); })) === null || _b === void 0 ? void 0 : _b.balanceToken;
            if (!balanceToken) {
                throw new Error("No balance token found for company with ID ".concat(companyId, "."));
            }
            var _c = get().decodeBalanceToken({ token: balanceToken }), data = _c.data, error = _c.error;
            if (error) {
                throw error;
            }
            if (data.creditBalance < CREDITS_NEEDED_FOR_SINGLE_SCAN) {
                throw new Error("Not enough credits to reserve.");
            }
            console.log("[".concat(moment().format('HH:mm:ss'), "] Reserved 1 credit for company ").concat(companyId, "."));
            // Only reserve credits and don't decrease the balance, since the balance is only decreased on the server.
            set(function (state) {
                var credit = state.credits.find(function (credit) { return credit.companyId === companyId.toString(); });
                credit.reservedCredits += CREDITS_NEEDED_FOR_SINGLE_SCAN;
            });
        },
        withdrawReservedCredits: function (_a) {
            var companyId = _a.companyId;
            var CREDITS_TO_WITHDRAW = 1;
            var creditSet = get().credits.find(function (credit) { return credit.companyId === companyId.toString(); });
            if (!creditSet) {
                throw new Error("No credit set found for company with ID ".concat(companyId, ". Can't withdraw credits."));
            }
            if (creditSet.reservedCredits < CREDITS_TO_WITHDRAW) {
                throw new Error("No reserved credits to withdraw for company ID ".concat(companyId, "."));
            }
            set(function (state) {
                var credit = state.credits.find(function (credit) { return credit.companyId === companyId.toString(); });
                credit.reservedCredits -= CREDITS_TO_WITHDRAW;
            });
            console.log("[".concat(moment().format('HH:mm:ss'), "] Withdrew 1 reserved credit for company ").concat(companyId, "."));
            return CREDITS_TO_WITHDRAW;
        },
    }
}); }), {
    name: 'bsp:credit-store',
    storage: createJSONStorage(function () { return localStorage; }),
    partialize: function (state) { return ({
        credits: state.credits,
    }); },
    merge: function (persisted, current) {
        return merge(current, persisted);
    }
}));
